import {createApp} from 'vue'
import NoSearchResults from './NoSearchResults'

const el = '.kb-component--no-search-results'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((NoSearchResultsDOM)=>{
            const guids = NoSearchResultsDOM.dataset.guids 
                ? JSON.parse(NoSearchResultsDOM.dataset.guids) 
                : []

            const component = createApp(NoSearchResults, { guids }).use(Store)
            component.mount(NoSearchResultsDOM)
        })
    }
}